import { render, staticRenderFns } from "./ModificationPage.vue?vue&type=template&id=3e794e76"
import script from "./ModificationPage.vue?vue&type=script&lang=js"
export * from "./ModificationPage.vue?vue&type=script&lang=js"
import style0 from "./ModificationPage.vue?vue&type=style&index=0&id=3e794e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports